
export const formatoCuentaRegresiva = (seconds, { short = false } = {}) => {

    const pad = num => num < 10 ? `0${num}` : num

    const h = pad(Math.floor(seconds / 3600))
    const m = pad(Math.floor(seconds % 3600 / 60))
    const s = pad(seconds % 60)

    if (short) {
      let result = ''
      if (h > 0) result += `${+h}:`
      result += `${h > 0 ? m : +m}:${s}`
      return result
    } else {
      return `${h}:${m}:${s}`
    }

}